import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";

/**
 * Botón de apertura del menú lateral con icono de menú hamburguesa.
 * Al hacer clic abre o cierra el menú de navegación.
 */
export function SidebarArrowTrigger({ label }: { label: string }) {
  const { toggleSidebar } = useSidebar();

  return (
    <Button
      type="button"
      data-sidebar="trigger"
      variant="ghost"
      size="icon"
      className="h-11 w-11 shrink-0 touch-manipulation"
      aria-label={label}
      onClick={toggleSidebar}
    >
      <Menu className="h-5 w-5" strokeWidth={2.75} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </Button>
  );
}
